import { FC, useState } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { TRANSLATION_KEYS } from '../../configs/translations'
import { IFinancialPlanQuality } from '../../model/types'
import { FinancialPlanQualityPillar } from '../financialPlanQuality/components/financialPlanQualityPillar/FinancialPlanQualityPillar'
import { FinancialPlanScoreInfo } from '../financialPlanQuality/components/financialPlanScoreInfo/FinancialPlanScoreInfo'

import styles from './FinancialPlanQualityContent.module.scss'

interface IFinancialPlanQualityContentProps {
  quality: IFinancialPlanQuality
  onCategoryPlanningClick?: () => void
  isPlanningOpenInNewTab?: boolean
}

/** The reusable part of Financial Plan Quality. It deliberately contains only the applicable scoring
 * pillars, so consumers such as Planning Cockpit can provide their own surrounding summary. */
export const FinancialPlanQualityContent: FC<IFinancialPlanQualityContentProps> = ({
  quality,
  onCategoryPlanningClick,
  isPlanningOpenInNewTab = false,
}) => {
  const [isScoreInfoVisible, setIsScoreInfoVisible] = useState(false)

  return (
    <>
      <div className={styles.pillars}>
        <FinancialPlanQualityPillar
          title={TRANSLATION_KEYS.quality.financialGrowth.title}
          description={TRANSLATION_KEYS.quality.financialGrowth.description}
          pillar={quality.financialGrowth}
          onHowScore={() => setIsScoreInfoVisible(true)}
          onCategoryPlanningClick={onCategoryPlanningClick}
          isPlanningOpenInNewTab={isPlanningOpenInNewTab}
        />

        {quality.sobGrowth.categories.length > 0 && (
          <FinancialPlanQualityPillar
            title={TRANSLATION_KEYS.quality.sobGrowth.title}
            description={TRANSLATION_KEYS.quality.sobGrowth.description}
            pillar={quality.sobGrowth}
            onHowScore={() => setIsScoreInfoVisible(true)}
            onCategoryPlanningClick={onCategoryPlanningClick}
            isPlanningOpenInNewTab={isPlanningOpenInNewTab}
          />
        )}
      </div>

      <ModalDialog
        show={isScoreInfoVisible}
        onClose={() => setIsScoreInfoVisible(false)}
        content={() => <FinancialPlanScoreInfo />}
        size={'xs'}
      />
    </>
  )
}
